export default "__VITE_ASSET__BRL9l17Q__"